import {
	Box,
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	SimpleGrid,
	useDisclosure,
	Text,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { Form, Formik } from 'formik';
import { mappingKhmerNumber } from '../../../utils/market-development';
import CompanyTypeFormField from './ews-summary-company-type-field';
import CompanyFormField from './ews-summary-company-field';
import SelectValueFormField from '../../../components/form/SelectValueFormField';
import useStore from '../../../store';
import c from '../../../constant';
import * as Yup from 'yup';
import moment from 'moment';

const validationSchema = Yup.object().shape({
	companyType: Yup.string().nullable(),
	companyId: Yup.string().nullable(),
	year: Yup.string().nullable(),
});

export default function EwsSummaryFilter({
	period = null,
	reportId = null,
	report = null,
	companyType = null,
	companyId = null,
	year = null,
	onCallback = () => null,
}) {
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state.currentLang);
	const { isOpen, onOpen, onClose } = useDisclosure();

	return (
		<>
			<Button
				isLoading={false}
				isDisabled={false}
				onClick={onOpen}
				leftIcon={<FontAwesomeIcon icon={faSlidersH} style={{ fontSize: 16 }} />}
				colorScheme={companyType || companyId || year ? 'yellow' : 'gray'}
				variant="solid"
				size="sm"
				borderRadius={c.borderRadius}
				border="1px solid #bdc3c7"
			>
				<Text fontSize="sm" fontWeight="semibold">
					{t('Filter')}
				</Text>
			</Button>
			<Modal borderRadius={c.borderRadius} isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent borderRadius={c.borderRadius}>
					<ModalHeader>{t('Filter')}</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Formik
							validationSchema={validationSchema}
							initialValues={{
								companyType: companyType || '',
								companyId: companyId || '',
								year: year || '',
							}}
							onSubmit={(values) => {
								let url = '?period=' + period + '&reportId=' + reportId + '&report=' + report;
								if (values?.companyType) {
									url = url + `&companyType=${values?.companyType}`;
								}
								if (values?.companyId) {
									url = url + `&companyId=${values?.companyId}`;
								}
								if (values?.year) {
									url = url + `&year=${values?.year}`;
								}
								onCallback(url);
								onClose();
							}}
						>
							{({ values, ...props }) => {
								return (
									<Box pb="4">
										<Form>
											<SimpleGrid columns={1} spacing={4}>
												<CompanyTypeFormField
													{...props}
													name="companyType"
													label="Company Type"
													formNameCompanyId="companyId"
													placeholder={t('Company Type')}
												/>
												<CompanyFormField {...props} name="companyId" label="Company" formNameCompanyType="companyType" />
												<SelectValueFormField
													{...props}
													placeholder={t('Year')}
													name="year"
													label="Year"
													options={[0].reduce((p, c) => {
														let lp = p;
														let i = 2021;
														while (i <= moment().year()) {
															lp.push({ label: lang === 'kh' ? mappingKhmerNumber(i) : i, value: i });
															i = i + 1;
														}
														return lp?.reverse();
													}, [])}
												/>
												<Flex mt={2} justifyContent="flex-end">
													<Button
														mr={2}
														colorScheme="gray"
														variant="solid"
														size="md"
														h="42px"
														w="128px"
														borderRadius={c.borderRadius}
														onClick={() => {
															let url = '?period=' + period + '&reportId=' + reportId + '&report=' + report;
															onCallback(url);
															onClose();
														}}
													>
														{t('Clear')}
													</Button>
													<Button
														ml={2}
														colorScheme="blue"
														variant="solid"
														size="md"
														h="42px"
														w="128px"
														type="submit"
														borderRadius={c.borderRadius}
													>
														{t('Apply')}
													</Button>
												</Flex>
											</SimpleGrid>
										</Form>
									</Box>
								);
							}}
						</Formik>
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
}
